import React, { useEffect, useRef } from "react";
import "./swiper.css";
import "swiper/element/css/pagination";
import { register } from "swiper/element/bundle";
// import function to register Swiper custom elements
// register Swiper custom elements
register();

const SwiperComp = ({ images }) => {

    const innerWidth = window.innerWidth;

    const swiperElRef = useRef(null);
  
    useEffect(() => {
      // listen for Swiper events using addEventListener
      swiperElRef.current.addEventListener("swiperprogress", (e) => {
        // const [swiper, progress] = e.detail;
        // console.log(progress);
      });
  
      swiperElRef.current.addEventListener("swiperslidechange", (e) => {
        // console.log("slide changed");
      });
    }, []);

  return (
    <div>
      <swiper-container
        ref={swiperElRef}
        slides-per-view={innerWidth > "900" ? "3.2" : "1"}
        space-between="25"
        // navigation="true"
        // pagination="true"
        speed="100"
        // loop="true"
        autoplay-delay="5000"
        css-mode="true"
      >
        {images?.length > 0 &&
          images?.map((item, idx) => {
            return (
              <swiper-slide key={idx} className="slide-cont" lazy="true">
                <img src={item?.link} alt="lazy" />
              </swiper-slide>
            );
          })}
      </swiper-container>
    </div>
  );
};

export default SwiperComp;
